import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuantityDiscountComponent } from './quantity-discount.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { createCustomElement } from '@angular/elements';
import { SanitizePipeModule } from '@digistore/ds24-ui/pipes';
import { PipesModule } from '../../../pipes/pipes.module';

@NgModule({
  declarations: [QuantityDiscountComponent],
  exports: [QuantityDiscountComponent],
  imports: [CommonModule, OverlayPanelModule, SanitizePipeModule, PipesModule],
})
export class QuantityDiscountModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(QuantityDiscountComponent, {
      injector: injector,
    });
    customElements.define(
      'ds-orderform-product-quantity-discount',
      customComponent
    );
  }
}
